import React from 'react';
import { TableRow, TableCell, Link } from '@mui/material';

const AdminTableRow = ({
  id,
  onClickCustomer,
  onClickContact,
  providerName,
  customerName,
  contactName,
  contactEmail,
  contactPhone,
  contactDepartment,
  accessLevel,
}) => (
  <TableRow key={id} id={id}>
    <TableCell>{providerName}</TableCell>
    <TableCell>
      <Link tabIndex={0} onClick={onClickCustomer}>
        {customerName}
      </Link>
    </TableCell>
    <TableCell>
      <Link tabIndex={0} onClick={onClickContact}>
        {contactName}
      </Link>
    </TableCell>
    <TableCell>{contactEmail}</TableCell>
    <TableCell>{contactPhone}</TableCell>
    <TableCell>{contactDepartment}</TableCell>
    <TableCell>{accessLevel}</TableCell>
  </TableRow>
);

export default AdminTableRow;
